import { render } from "./csrf_token_input.vue?vue&type=template&id=23e8d1b4"
import script from "./csrf_token_input.vue?vue&type=script&lang=js"
export * from "./csrf_token_input.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__